import { render, staticRenderFns } from "./MessageAttachments.vue?vue&type=template&id=4581cb4c"
import script from "./MessageAttachments.vue?vue&type=script&lang=js"
export * from "./MessageAttachments.vue?vue&type=script&lang=js"
import style0 from "./MessageAttachments.vue?vue&type=style&index=0&id=4581cb4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports